<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0 d-flex align-items-center justify-content-center">
      <b-col
        xs="12"
        sm="8"
        md="6"
        lg="4"
        class="d-flex align-items-center card p-5"
      >
        <ds-breeze-logo
          class="auth-logo"
          :height="28"
        />
        <b-col>
          <h1 class="auth-title">
            Set your password
          </h1>
          <p class="auth-description">
            Welcome! Set a password for <strong>{{ username }}</strong> to get started.
          </p>

          <ds-note
            v-if="errorMessage"
            variant="danger"
            live="alert"
          >
            {{ errorMessage }}
          </ds-note>

          <validation-observer ref="setupPasswordValidation">
            <b-form @submit.prevent="handleSubmit">
              <div class="auth-field">
                <label
                  class="auth-label"
                  for="setup-username"
                >Username</label>
                <!-- type="text": this shows the account's username, which is not always an
                     email address. -->
                <ds-input
                  id="setup-username"
                  :value="username"
                  type="text"
                  autocomplete="username"
                  readonly
                />
              </div>

              <validation-provider
                #default="{ errors }"
                name="Password"
                vid="password"
                rules="required|min:8|password"
              >
                <ds-password-input
                  id="setup-password"
                  v-model="password"
                  label="Password"
                  placeholder="Your password"
                  autocomplete="new-password"
                  :error="errors[0]"
                />
              </validation-provider>

              <div class="auth-field">
                <label
                  class="auth-label"
                  for="setup-password-confirm"
                >Confirm password</label>
                <validation-provider
                  #default="{ errors }"
                  name="Confirm Password"
                  rules="required|confirmed:password"
                >
                  <ds-input
                    id="setup-password-confirm"
                    v-model="passwordConfirm"
                    type="password"
                    autocomplete="new-password"
                    placeholder="Repeat your password"
                    :invalid="errors.length > 0"
                    :aria-describedby="errors.length > 0 ? 'setup-password-confirm-error' : null"
                  />
                  <div
                    id="setup-password-confirm-error"
                    class="auth-error"
                    role="alert"
                  >
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>

              <ds-button
                type="submit"
                class="auth-submit"
                :disabled="submitting"
              >
                {{ submitting ? 'Setting password...' : 'Set password' }}
              </ds-button>
            </b-form>
          </validation-observer>
        </b-col>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BRow, BCol, BForm } from 'bootstrap-vue'
import {
  DsBreezeLogo, DsButton, DsInput, DsNote, DsPasswordInput,
} from '@/design-system/components'
import {
  required, min, confirmed, password as passwordRule,
} from '@validations'
import { userService } from '@/_services/user.service'

export default {
  components: {
    DsBreezeLogo,
    DsNote,
    DsInput,
    DsPasswordInput,
    DsButton,
    BRow,
    BCol,
    BForm,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      password: '',
      passwordConfirm: '',
      token: '',
      username: '',
      submitting: false,
      errorMessage: '',
      required,
      min,
      confirmed,
      passwordRule,
    }
  },
  computed: {
  },
  created() {
    this.token = this.$route.query.token || ''
    this.username = this.$route.query.username || ''

    if (!this.token) {
      this.errorMessage = 'Invalid link. Please use the link from your email.'
    }
  },
  methods: {
    handleSubmit() {
      this.$refs.setupPasswordValidation.validate().then(success => {
        if (!success) return

        this.submitting = true
        this.errorMessage = ''

        userService.setupPassword(this.token, this.password)
          .then(() => {
            this.$notify.success('Your password has been set successfully. Please sign in.', { title: 'Password Set!' })
            this.$router.push({ name: 'login', query: { username: this.username } })
          })
          .catch(() => {
            this.errorMessage = 'Link expired or password already set. Please contact support.'
          })
          .finally(() => {
            this.submitting = false
          })
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>

<style lang="scss" scoped>
@import './auth-form';
</style>
